import { useAuth } from '../src/user/UserContext'

export function useIsAllowedToFullUse() {
	const auth = useAuth()
	const signedAndVerifiedUser =
		auth.status === 'signedIn' && auth.user.verifiedAt && auth.user.verifiedAt < new Date().toISOString()
	if (signedAndVerifiedUser) {
		return true
	}
	return false
}
